// --------------------------------------------------------------------------
// autoFocus.js
// --------------------------------------------------------------------------

RN.autoFocus = function() {

  'use strict';

  function init() {
    var field = byBehaviour('auto-focus');

    if(field.length > 0){
        field.focus();
    }
  }

  return {
    init: init
  };

}();